import React from 'react';
import { useModuleAccess } from '../contexts/ModuleAccessContext';
import { Users, Building2, Bell } from 'lucide-react';

interface CompanyMenuProps {
  isOpen: boolean;
  onClose: () => void;
  setActiveSection: (section: string) => void;
}

const CompanyMenu: React.FC<CompanyMenuProps> = ({ 
  isOpen, 
  onClose,
  setActiveSection
}) => {
  const { isAdmin } = useModuleAccess();
  if (!isOpen) return null;

  return (
    <div className="absolute top-full left-0 w-64 mt-1 bg-white border rounded-lg shadow-lg z-[120] py-1 whitespace-nowrap">
      <button 
        className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
        onClick={() => {
          setActiveSection('company-profile');
          onClose();
        }}
      >
        <Building2 className="w-4 h-4 text-gray-400" />
        <span>Perfil da Empresa</span>
      </button>
      
      {isAdmin && (
        <button 
          className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
          onClick={() => {
            setActiveSection('user-management');
            onClose();
          }}
        >
          <Users className="w-4 h-4 text-gray-400" />
          <span>Gestão de acessos</span>
        </button>
      )}
      
      <button 
        className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
        onClick={() => {
          setActiveSection('company-notifications');
          onClose();
        }}
      >
        <Bell className="w-4 h-4 text-gray-400" />
        <span>Notificações</span>
      </button>
    </div>
  );
};

export default CompanyMenu;